import React from 'react';

import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
} from '@dnd-kit/core';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import { useEffect, useState } from 'react';

import { useNavigate, Link } from 'react-router-dom';

import { Container, FormControl, FormGroup, FormLabel } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import { Table } from 'react-bootstrap';

import { Button } from 'react-bootstrap';

import FAQStore from '../../../stores/FAQStore';

const FAQItemListPage = ({ users }) => {
    const navigate = useNavigate();

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        }),
    );

    const store = FAQStore((state) => state);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(9);
    const [lastPage, setLastPage] = useState(1);
    const [totalResults, setTotalResults] = useState(0);
    const [items, setItems] = useState(store.faqItems);

    const [isOrderLocked, setIsOrderLocked] = useState(true);

    useEffect(() => {
        const success = (res) => {
            setLastPage(res.lastPage);
            setTotalResults(res.totalResults);
            setItems(res);
        };
        store.loadAll(pageSize, currentPage, success);
        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
    }, []);

    if (null != store.faqItems) {
        var tableRows = store.faqItems.map(function (faqItem, i) {
            return (
                <tr key={'user-' + i}>
                    <td>
                        <a
                            href="#"
                            onClick={() => {
                                navigate('edit/' + faqItem.id);
                            }}
                        >
                            {faqItem.id}
                        </a>
                    </td>
                    <td>
                        <a
                            href="#"
                            onClick={() => {
                                navigate('edit/' + faqItem.id);
                            }}
                        >
                            {faqItem.position}
                        </a>
                    </td>
                    <td>
                        <div
                            onClick={() => {
                                navigate('edit/' + faqItem.id);
                            }}
                        >
                            {faqItem.title}
                        </div>
                    </td>
                </tr>
            );
        });
    }

    function SortableItem(props) {
        const { attributes, listeners, setNodeRef, transform, transition } =
            useSortable({ id: props.id });

        const style = {
            transform: CSS.Transform.toString(transform),
            transition,
        };

        const faqItem = props.faqItem;

        return (
            <tr
                key={'faqItem-' + faqItem.id}
                ref={setNodeRef}
                style={style}
                {...attributes}
                {...listeners}
            >
                <td>{faqItem.id}</td>
                <td>{faqItem.position}</td>
                <td>{faqItem.title}</td>
            </tr>
        );
    }

    function handleDragEnd(event) {
        const { active, over } = event;

        if (active.id !== over.id) {
            setItems((faqItems) => {
                let oldIndex = -1;
                for (let i = 0; i < faqItems.length; i++) {
                    if (active.id == faqItems[i].id) {
                        oldIndex = i;
                    }
                }

                let newIndex = -1;
                for (let i = 0; i < faqItems.length; i++) {
                    if (over.id == faqItems[i].id) {
                        newIndex = i;
                    }
                }

                let newItems = arrayMove(faqItems, oldIndex, newIndex);

                // Modify the ordinal positions of each of the items
                for (let i = 0; i < faqItems.length; i++) {
                    newItems[i].position = i;
                }
                return newItems;
            });
        }
    }

    return (
        <Container style={{ marginTop: '10px', width: '100%' }}>
            <Row className="show-Container">
                <Col xs={12} md={8}>
                    <Button
                        onClick={() => {
                            navigate('create');
                        }}
                    >
                        Create FAQ Item
                    </Button>
                </Col>
            </Row>
            <br />
            <Row className="show-Container">
                <Col xs={12} md={8}>
                    <FormGroup
                        controlId={'Search-text-input'}
                        style={{ marginBottom: '18px' }}
                    >
                        <FormLabel>Filter</FormLabel>
                        <FormControl
                            type="text"
                            onChange={(e) => {
                                console.log(e.target.value);
                            }}
                        />
                    </FormGroup>

                    <Button
                        style={{
                            marginBottom: '10px',
                            float: 'right',
                            marginLeft: '10px',
                        }}
                        onClick={() => {
                            setIsOrderLocked(!isOrderLocked);
                        }}
                    >
                        {isOrderLocked ? 'Unlock Item Order' : 'Cancel'}
                    </Button>

                    {isOrderLocked ? null : (
                        <Button
                            style={{ marginBottom: '10px', float: 'right' }}
                            onClick={() => {
                                store.updatePositions(items, () => {
                                    setIsOrderLocked(!isOrderLocked);
                                });
                            }}
                        >
                            Save Item Order
                        </Button>
                    )}

                    {isOrderLocked ? null : (
                        <Table striped bordered condensed="true" hover>
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Position in List</th>
                                    <th>Title</th>
                                </tr>
                            </thead>

                            <tbody>
                                {null != items ? (
                                    <DndContext
                                        sensors={sensors}
                                        collisionDetection={closestCenter}
                                        onDragEnd={handleDragEnd}
                                    >
                                        <SortableContext
                                            items={items}
                                            strategy={
                                                verticalListSortingStrategy
                                            }
                                        >
                                            {items.map((faqItem) => (
                                                <SortableItem
                                                    key={faqItem.id}
                                                    id={faqItem.id}
                                                    faqItem={faqItem}
                                                />
                                            ))}
                                        </SortableContext>
                                    </DndContext>
                                ) : null}
                            </tbody>
                        </Table>
                    )}

                    {isOrderLocked ? (
                        <Table striped bordered condensed="true" hover>
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Position in List</th>
                                    <th>Title</th>
                                </tr>
                            </thead>

                            <tbody>{tableRows}</tbody>
                        </Table>
                    ) : null}
                </Col>
            </Row>
        </Container>
    );
};

export default FAQItemListPage;
